import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './styles.css'
import * as FaIcons from 'react-icons/fa';
import { Modal, Button } from "react-bootstrap";
import AxiosService from '../services/axios.service';
import Multiselect from 'multiselect-react-dropdown';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';

const API_PATH = "users";

function List({ match }) {
    const { path } = match;
    const [users, setUsers] = useState(null);
    const [deleteId, setDeleteId] = useState(0);
    const [show, setShow] = useState(false);
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState([]);
    const [emails, setEmails] = useState([]);

    useEffect(() => {
        AxiosService.getAll(API_PATH).then(x => setUsers(x.data) & setOptions(x.data));
    }, []);

    function onSelect(selectedList, selectedItem) {
        setEmails(selectedList);
    }

    function onRemove(selectedList, removedItem) {
        setEmails(selectedList);
    }

    const handleClose = () => {
        setShow(false);
        console.log("close");
    };

    const confirmDelete = (id) => {
        setShow(true);
        setDeleteId(id);
    };

    function deleteRequest() {
        console.log("deleting user id: " + deleteId);
        setUsers(users.map(x => {
            if (x.id === deleteId) { x.isDeleting = true; }
            return x;
        }));
        AxiosService.delete(API_PATH, deleteId).then(() => {
            setUsers(users => users.filter(x => x.id !== deleteId));
        });
        setShow(false);
    };

    const { register, watch, handleSubmit, reset, setValue, errors, formState } = useForm({
    });

    function onSubmit(data) {
        var email_list = [];
        for (var x in emails) {
            var user = emails[x];
            email_list.push(user.email);
        }
        data.emails = email_list;
        AxiosService.create("emails", data)
            .then(() => {
                console.log(email_list.toString());
            })
    }

    return (
        <div>
            <h4>Users</h4>
            <Link to={`${path}/add`} className="btn btn-sm btn-success mb-2"><FaIcons.FaUserPlus size={22} /></Link>
            <table className="table table-striped">
                <thead>
                    <tr >
                        <th style={{ width: '20%' }}>Name</th>
                        <th style={{ width: '20%' }}>Email</th>
                        <th style={{ width: '10%' }}>Role</th>
                        <th style={{ width: '20%' }}>Page Access</th>
                        <th style={{ width: '20%' }}></th>
                    </tr>
                </thead>
                <tbody >
                    {users && users.map(user =>
                        <tr key={user.id}>
                            <td>{user.first_name} {user.last_name}</td>
                            <td>{user.email}</td>
                            <td>{user.role}</td>
                            <td>{user.access}</td>
                            <td>
                                <Link to={`${path}/edit/${user.id}`} className="btn btn-sm btn-primary mr-2"> <FaIcons.FaUserEdit size={22} /> </Link>
                                <button onClick={() => confirmDelete(user.id)} className="btn btn-sm btn-danger mr-2"> <FaIcons.FaUserMinus size={22} />
                                </button>
                                {/* <button onClick={() => deleteUser(user.id)}  style= {{ width: 50}} className="btn btn-sm btn-danger btn-delete-user" disabled={user.isDeleting}> */}
                                {/*<ConfirmButton
                                             dialog={["", "Delete?", "CONFIRM DELETE"]}
                                        action={() => deleteUser(user.id)}
                                    
                                        disabled={user.isDeleting}
                                    />
                                    {user.isDeleting 
                                        ? <span className="spinner-border spinner-border-sm"></span>
                                        : <span style={{fontWeight:'bold'}}></span>
                                    }*/}
                                {/* </button> */}
                            </td>
                        </tr>
                    )}
                    {!users &&
                        <tr>
                            <td colSpan="4" className="text-center">
                                <div className="spinner-border spinner-border-lg align-center"></div>
                            </td>
                        </tr>
                    }
                    {users && !users.length &&
                        <tr>
                            <td colSpan="4" className="text-center">
                                <div className="p-2">No Users To Display</div>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete?</Modal.Title>
                </Modal.Header>
                <Modal.Body>Would you like to delete this Request?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => deleteRequest(users.id)}>
                        OK
                    </Button>
                    <Button variant="primary" onClick={handleClose}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export { List };